export function normalizeSiteSource(raw) {
  const stripped = (raw || "").trim().replace(/^https?:\/\//i, "");
  const match = stripped.match(/^([^/?#]*)([^?#]*)(\?[^#]*)?/);
  if (!match) {
    return "";
  }
  const path = match[2] === "/" ? "" : match[2].replace(/\/$/, "");
  return match[1].toLowerCase() + path + (match[3] || "");
}

export function hostOf(raw) {
  const normalized = normalizeSiteSource(raw);
  if (!normalized) {
    return "";
  }
  try {
    return new URL(`https://${normalized}`).hostname;
  } catch (error) {
    return "";
  }
}
